import { css } from 'styled-components';
import { FocusStyles } from '../../../styles/FocusStyles';
const buttonBaseStyle = css `
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1.0625rem;
  padding-left: 1.375rem;
  padding-right: 1.375rem;
  text-transform: uppercase;
  border-radius: 1.15625rem;
  height: 2.3152rem;

  ${FocusStyles}
`;
const buttonBaseStyleSmall = css `
  text-transform: inherit;
  font-size: 0.75rem;
  font-weight: 500;
  height: 1.625rem;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  border-radius: 0.8125rem;

  ${FocusStyles}
`;
function primaryButtonStyle(props) {
    const baseStyle = css `
    ${buttonBaseStyle}
    color: ${props.theme.White};
  `;
    if (props['data-disabled']) {
        return baseStyle.concat(css `
      background-color: ${props.theme.DirtyWhiteDarker};
      box-shadow: 0 0.25rem 0 0 ${props.theme.LightGray};
      color: ${props.theme.LightGray};

      &:hover,
      &:focus,
      &:active {
        box-shadow: 0 0.25rem 0 0 ${props.theme.LightGray};
      }
    `);
    }
    return baseStyle.concat(css `
    background-color: ${props.theme.BrandPrimary};
    box-shadow: 0 0.25rem 0 0 ${props.theme.BrandPrimaryHover};
    margin-bottom: 0.25rem;

    &:hover {
      transform: ${props.isPending ? 'translateY(0)' : 'translateY(-0.125rem)'};
      box-shadow: ${props.isPending ? '0 0.25rem 0 0' : '0 0.375rem 0 0 '}
        ${props.theme.BrandPrimaryHover};
    }

    &:active {
      transform: ${props.isPending ? 'translateY(0)' : 'translateY(0.125rem)'};
      box-shadow: ${props.isPending ? '0 0.25rem 0 0' : '0 0.125rem 0 0 '}
        ${props.theme.BrandPrimaryHover};
    }
  `);
}
function primarySmallButtonStyle(props) {
    const baseStyle = css `
    ${buttonBaseStyleSmall}
    color: ${props.theme.White};
  `;
    if (props['data-disabled']) {
        return baseStyle.concat(css `
      background-color: ${props.theme.DirtyWhiteDarker};
      box-shadow: 0 0.125rem 0 0 ${props.theme.LightGray};
      color: ${props.theme.LightGray};

      &:hover,
      &:focus,
      &:active {
        box-shadow: 0 0.125rem 0 0 ${props.theme.LightGray};
      }
    `);
    }
    return baseStyle.concat(css `
    background-color: ${props.theme.BrandPrimary};
    box-shadow: 0 0.125rem 0 0 ${props.theme.BrandPrimaryHover};
    margin-bottom: 0.125rem;

    &:hover {
      transform: ${props.isPending
        ? 'translateY(0)'
        : 'translateY(-0.0625rem)'};
      box-shadow: ${props.isPending ? '0 0.125rem 0 0' : '0 0.25rem 0 0 '}
        ${props.theme.BrandPrimaryHover};
    }

    &:active {
      transform: ${props.isPending ? 'translateY(0)' : 'translateY(0.125rem)'};
      box-shadow: none;
    }
  `);
}
function secondaryButtonStyle(props) {
    const baseStyle = css `
    ${buttonBaseStyle}
  `;
    if (props['data-disabled']) {
        return baseStyle.concat(css `
      background-color: ${props.theme.GrayLightest};
      box-shadow: 0 0.25rem 0 0 ${props.theme.DirtyWhiteDarker};
      color: ${props.theme.colors.DirtyWhiteDarker};

      &:hover,
      &:focus,
      &:active {
        box-shadow: 0 0.25rem 0 0 ${props.theme.DirtyWhiteDarker};
      }
    `);
    }
    return baseStyle.concat(css `
    background-color: ${props.styling === 'secondaryWhite'
        ? props.theme.White
        : props.theme.Anthracite};
    box-shadow: 0 0.25rem 0 0 ${props.theme.DirtyWhite};
    margin-bottom: 0.25rem;
    color: ${props.theme.BrandPrimary};

    &:hover {
      transform: translateY(-0.125rem);
      box-shadow: 0 0.375rem 0 0 ${props.theme.DirtyWhite};
    }

    &:active {
      transform: translateY(0.125rem);
      box-shadow: 0 0.125rem 0 0 ${props.theme.DirtyWhite};
    }
  `);
}
function secondarySmallButtonStyle(props) {
    const baseStyle = css `
    ${buttonBaseStyleSmall}
  `;
    if (props['data-disabled']) {
        return baseStyle.concat(css `
      background-color: ${props.theme.GrayLightest};
      box-shadow: 0 0.125rem 0 0 ${props.theme.DirtyWhiteDarker};
      color: ${props.theme.colors.DirtyWhiteDarker};

      &:hover,
      &:focus,
      &:active {
        box-shadow: 0 0.125rem 0 0 ${props.theme.DirtyWhiteDarker};
      }
    `);
    }
    return baseStyle.concat(css `
    background-color: ${props.styling === 'secondarySmallWhite'
        ? props.theme.White
        : props.theme.Anthracite};
    box-shadow: 0 0.125rem 0 0 ${props.theme.DirtyWhite};
    margin-bottom: 0.125rem;
    color: ${props.theme.BrandPrimary};

    &:hover {
      transform: translateY(-0.0625rem);
      box-shadow: 0 0.25rem 0 0 ${props.theme.DirtyWhite};
    }

    &:active {
      transform: translateY(0.125rem);
      box-shadow: none;
    }
  `);
}
export const buttonStyle = css `
  /* reset user-agent-stylesheet padding for <button> to prevent 6px padding left and right */
  padding: 0;
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-family: ${props => props.theme.fonts.serif};
  justify-content: center;
  text-align: center;
  transform: translateY(0);
  transition: all 60ms ease;
  ${FocusStyles}

  ${props => props.styling === 'primary' && primaryButtonStyle(props)}

  ${props => props.styling === 'primarySmall' && primarySmallButtonStyle(props)}

  ${props => (props.styling === 'secondary' || props.styling === 'secondaryWhite') &&
    secondaryButtonStyle(props)}

  ${props => (props.styling === 'secondarySmall' ||
    props.styling === 'secondarySmallWhite') &&
    secondarySmallButtonStyle(props)};
`;
